export const GET_REGIONS = "GET_REGIONS";
export const GET_REGIONS_SUCCESS = "GET_REGIONS_SUCCESS";
export const GET_REGIONS_FAIL = "GET_REGIONS_FAIL";

export const GET_SPECS = "GET_SPECS";
export const GET_SPECS_SUCCESS = "GET_SPECS_SUCCESS";
export const GET_SPECS_FAIL = "GET_SPECS_FAIL";
